import {
    VIEW_PROJECTS
} from "../constant/ActionType";

export default function AllViewProject_reducer(state = {
    ViewProjectsData: [],
    lastPage: 1,
}, action) {
    switch (action.type) {
        case VIEW_PROJECTS:
            return {
                ...state,
                ViewProjectsData: action?.data?.data?.data,
                lastPage: action?.data?.data?.last_page,
                current_page: action?.data?.data?.current_page
            };

        default:
    }

    return state;
}